<template>
    <div class="order-detail-wrapper1" v-if="obj.id">
        <avue-form :option="option" v-model="obj" ref="form">
            <template slot="starOrderStatusList" slot-scope="scope">
                <el-steps size="mini" :active="obj.starOrderStatusList.length-1" align-center class="order-steps">
                    <el-step v-for="(item,index) in scope.dic" :title="item.dictValue" :key="index">
                        <template slot="icon" v-if="obj.starOrderStatusList[index]">
                            <el-popover placement="top-start" width="200" trigger="hover">
                                <div>
                                    <div class="flex">
                                        <div>
                                            <div>创建人：{{obj.starOrderStatusList[index].createUserName}}</div>
                                            <div>机构：{{obj.starOrderStatusList[index].createDeptName}}</div>
                                        </div>
                                        <!-- <el-button type="text">详情</el-button> -->
                                    </div>
                                    <div>时间：{{obj.starOrderStatusList[index]?getDateFormate(obj.starOrderStatusList[index].createTime):''}}</div>
                                </div>
                                <div slot="reference"><b>{{index+1}}</b></div>
                            </el-popover>
                        </template>
                        <template slot="description">
                            <div class="c9">{{obj.starOrderStatusList[index]?obj.starOrderStatusList[index].createUserName:''}}</div>
                            <div class="c9">{{obj.starOrderStatusList[index]?getDateFormate(obj.starOrderStatusList[index].createTime):''}}</div>
                        </template>
                    </el-step>
                </el-steps>
            </template>
            <template slot="initialPlanNo">
                <div class="num-family">{{obj.initialPlanNo}}</div>
            </template>
            <template slot="orderNo">
                <div class="num-family">{{obj.orderNo}}</div>
            </template>
            <template slot="qsgx">
                <kinship :isShowBtn="false" :isOpt="false" :isShowTitle="false" :orderId="obj.id" :list="obj.orderKinshipList"></kinship>
            </template>
            <template slot="residenceProvince">
                <div class="txt">
                    {{obj.orderPersonalData.residenceProvince}}{{obj.orderPersonalData.residenceCity}}{{obj.orderPersonalData.residenceDistrict}}{{obj.orderPersonalData.residenceAddress}}
                </div>
            </template>
            <template slot="actualResidenceProvince">
                <div class="txt">
                    {{obj.orderPersonalData.actualResidenceProvince}}{{obj.orderPersonalData.actualResidenceCity}}{{obj.orderPersonalData.actualResidenceDistrict}}{{obj.orderPersonalData.actualResidentialAddress}}
                </div>
            </template>
            <template slot="detailInit">
                <orderinitDetail :isShowTitle="true" :isOpt="false" :isSee="!showOpt" :isAdd="showOpt" :isShowBtn="false" :orderInitId="initOrderId" :date="new Date()" @getList="getorderInitialPlanList"></orderinitDetail>
            </template>
            <template slot="jhd">
                <orderinit :isShowBtn="false" :isOpt="false" :isShowTitle="false" :orderId="obj.id" :list="orderInitialPlanList"></orderinit>
            </template>
        </avue-form>
        <div class="tac mt20">
            <el-button type="primary" size="mini" @click="closeVisible">返回</el-button>
            <el-button type="primary" size="mini" v-if="showOpt" @click="submit">提交到分中心</el-button>
            <el-button type="primary" size="mini" @click="orderDetailVisible=true">打印计划</el-button>
            <el-button type="primary" size="mini" v-if="isShenHe" @click="submit">审核</el-button>
        </div>
        <el-dialog title="计划单详情" fullscreen append-to-body width="80%" :visible.sync="orderDetailVisible" v-if="orderDetailVisible">
            <pdf :info="detail" :type="3" @close="orderDetailVisible = false"></pdf>
        </el-dialog>
        <el-dialog title="审核" append-to-body width="600px" :visible.sync="examinelVisible">
            <avue-form ref="examineForm" v-model="examineForm" :option="examineOption" @submit="submitExaminel">
            </avue-form>
        </el-dialog>
    </div>
</template>
<script>
// import orderjudicial from '@/components/orderjudicial/index.vue'
import kinship from '@/components/kinship/index.vue'
import orderinit from '@/components/orderinit/index.vue'
import pdf from '@/views/archives/components/jtjh-pdf.vue'

import { dateFormat } from "@/util/date"
import { getDictionary } from "@/api/system/dictbiz"

import { update, getOrderInitPlanList, auditOneHandle, submitAudit2Handle, auditTwoHandle } from "@/api/order/orderinit";
import orderinitDetail from '@/components/orderinit/detail.vue'
import { getDictTree } from "@/api/system/dictbiz"
export default {
    name: 'order-detail',
    props: {
        detail: {
            type: Object,
            default: {}
        },
        isOpt: {
            type: Boolean,
            default: true
        },
        isShenHe: {
            type: Boolean,
            default: true
        },
        initOrderId: {
            type: String,
        },
        isSuccess: {
            type: Boolean,
            default: false
        },
        status: {
            type: Number
        }
    },
    components: {
        // orderjudicial,
        kinship,
        orderinit,
        pdf,
        orderinitDetail
    },
    computed: {
        getDateFormate() {
            return function(date) {
                return dateFormat(new Date(date), "yyyy-MM-dd")
            }
        }
    },
    watch: {
        // detail: {
        //     deep: true,
        //     handler(val) {
        //         this.init()
        //     },
        // },
        status() {
            this.auditStatus = this.status
        }
    },
    data() {
        return {
            auditStatus: '',
            examinelVisible: false,
            examineForm: {},
			specificImageBytext:true,
            examineOption: {
                column: [{
                        label: '状态',
                        prop: 'result',
                        row: true,
                        span: 24,
                        dataType: 'number',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: 'sub-center-approval-organization-plan_status'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        rules: [{
                            required: true,
                            message: "请选择状态",
                            trigger: "click"
                        }],
                        change: (value) => {
                            let column = this.examineOption.column.find(v => v.prop == "remark")
                            if (value.value * 1 == 2) {
                                column.display = true
                                this.examineForm.remark = ""
                            } else {
                                column.display = false
                            }
                        },
                    },
                    {
                        label: '原因',
                        prop: 'remark',
                        row: true,
                        display: false,
                        span: 24,
                        type: "textarea",
                        rules: [{
                            required: true,
                            message: "请填写原因",
                            trigger: "click"
                        }]
                    }
                ]
            },
            showOpt: true,
            orderDetailVisible: false,
            obj: {},
            orderKinshipList: [],
            starOrderJudicialList: [],
            orderInitialPlanList: [],
            option: {
                detail: true,
                group: [{
                        label: '订单详情',
                        prop: 'group1',
                        arrow: false,
                        column: [{
                            label: '订单号',
                            prop: 'orderNo',
                            span: 8
                        }, {
                            label: '计划单号',
                            prop: 'initialPlanNo',
                            span: 16
                        }, {
                            label: '经办人',
                            prop: 'orderCreateUserName',
                            span: 8
                        }, {
                            label: "订单类型",
                            prop: "type",
                            type: "select",
                            dataType: 'string',
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'work_type',
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            formatter: (row, value, label, column) => {
                                return label
                            },
                            span: 8
                        }, {
                            label: "优先级",
                            prop: "priority",
                            bind: 'orderPersonalData.priority',
                            type: "select",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'priority'
                            },

                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            span: 8
                        }, {
                            label: "五类青少年",
                            prop: "teenagersType",
                            bind: 'orderPersonalData.teenagersType',
                            type: "select",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'Five-youth_types'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            span: 8
                        }, {
                            label: '状态',
                            prop: 'status',
                            span: 8,
                            type: "select",
                            dataType: 'number',
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'order_status'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                        }, {
                            label: '发布时间',
                            prop: 'createTime',
                            span: 8
                        }, {
                            label: '完成时间',
                            prop: 'finishTime',
                            span: 8
                        }, {
                            label: "颜色标注",
                            prop: "orderColor",
                            type: "select",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'Color'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            span: 8
                        }, {
                            label: '服务机构',
                            prop: 'orderCreateDeptName',
                            span: 8
                        }, ]
                    }, {
                        label: '流程进度',
                        arrow: false,
                        prop: 'group2',
                        column: [{
                            labelWidth: '0',
                            prop: 'starOrderStatusList',
                            span: 24,
                            formslot: true,
                            row: true,
                            type: "select",
                            dicData: [],
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                        }]
                    }, {
                        label: '用户信息',
                        arrow: false,
                        prop: 'group3',
                        column: [{
                            label: "头像",
                            prop: "photoUrl",
                            bind: 'orderPersonalData.photoUrl',
                            type: 'upload',
                            listType: 'picture-img',
                            span: 24,
                            row: true
                        }, {
                            label: '用户姓名',
                            prop: 'name',
                            bind: "orderPersonalData.name",
                            span: 8
                        }, {
                            label: '出生年月',
                            prop: 'birthday',
                            bind: "orderPersonalData.birthday",
                            span: 8
                        }, {
                            label: '籍贯',
                            prop: 'nativePlace',
                            bind: "orderPersonalData.nativePlace",
                            span: 8
                        }, {
                            label: "身份证",
                            prop: "cardNo",
                            bind: 'orderPersonalData.cardNo',
                            span: 8
                        }, {
                            label: "性别",
                            prop: "gender",
                            bind: 'orderPersonalData.gender',
                            type: 'select',
                            dataType: "number",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'sex'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            },
                            span: 8
                        }, {
                            label: '健康状态',
                            prop: 'healthyState',
                            bind: "orderPersonalData.healthyState",
                            span: 8,
                            dataType: 'number',
                            type: "select",
                            dicUrl: "/api/blade-system/dict-biz/dictionary",
                            dicQuery: {
                                code: 'healthy'
                            },
                            props: {
                                label: "dictValue",
                                value: "dictKey"
                            }
                        }, {
                            label: '联系方式',
                            prop: 'contact',
                            bind: "orderPersonalData.contact",
                            span: 8
                        }, {
                            label: '户籍地址',
                            prop: 'residenceProvince',
                            bind: "orderPersonalData.residenceProvince",
                            formslot: true,
                            span: 24,
                            row: true,
                        }, {
                            label: '现住地址',
                            prop: 'actualResidenceProvince',
                            bind: "orderPersonalData.actualResidenceProvince",
                            formslot: true,
                            span: 24,
                            row: true
                        }]
                    }, {
                        label: '案件描述',
                        arrow: false,
                        prop: 'group4',
                        labelWidth: 45,
                        column: [{
                                labelWidth: 72,
                                label: "案件类型",
                                prop: "crimeType",
                                type: 'cascader',
                                dataType: "string",
                                emitPath: false,
                                // checkStrictly:true,
                                showAllLevels: false,
                                dicUrl: "/api/blade-system/dict-biz/dictionary",
                                dicQuery: {
                                    code: 'crime_types'
                                },
                                props: {
                                    label: "dictValue",
                                    value: "dictKey"
                                },
                                span: 24,
                                row: true,
                                // lazy:true
                            }, {
                                labelWidth: 72,
                                label: "涉案时间",
                                prop: "crimeTime",
                                type: "datetime",
                                span: 12,
                            }, {
                                labelWidth: 72,
                                label: "涉案区域",
                                prop: "regionCodeName",
                                span: 12,
                            }, {
                                labelWidth: 72,
                                label: "涉案场所",
                                prop: "placeTypeName",
                                span: 12,
                            },{
                                labelWidth: 72,
                                label: "情况描述",
                                prop: "crimeSituation",
                                type: 'textarea',
                                span: 24
                            },
                            //  {
                            //     labelWidth: 72,
                            //     label: "危险因素",
                            //     prop: "hazard",
                            //     type: "select",
                            //     dicUrl: "/api/blade-system/dict-biz/dictionary",
                            //     props: {
                            //         label: "dictValue",
                            //         value: "dictKey"
                            //     },
                            //     dicQuery: {
                            //         code: 'critical_factors_ype'
                            //     },
                            //     span: 24
                            // }, {
                            //     labelWidth: 100,
                            //     label: "危急因素备注",
                            //     prop: "hazardRemark",
                            //     span: 24
                            // },
                            {
                                labelWidth: 72,
                                label: "紧急服务",
                                prop: "emergencyServices",
                                type: "select",
                                dataType: "number",
                                dicData: [{
                                    label: '需要',
                                    value: 0
                                }, {
                                    label: '不需要',
                                    value: 1
                                }],
                                span: 24
                            }, {
                                labelWidth: 100,
                                label: "紧急服务备注",
                                prop: "emergencyServicesRemarks",
                                span: 24
                            },
                            // {
                            //     labelWidth: 72,
                            //     label: '案情概述',
                            //     prop: 'summarize',
                            //     span: 24,
                            //     formslot: true,
                            //     row: true
                            // }, {
                            //     labelWidth: 72,
                            //     label: '案情详情',
                            //     prop: 'detail',
                            //     span: 24,
                            //     formslot: true,
                            //     row: true
                            // }
                        ]
                    }, {
                        label: '服务情况',
                        arrow: false,
                        prop: 'group7',
                        labelWidth: 120,
                        column: [{
                                label: "曾经有使用相关服务记录",
                                labelWidth: 170,
                                prop: "isServiceSituation",
                                bind: 'orderPersonalData.isServiceSituation',
                                type: "select",
                                dataType: "number",
                                dicData: [{
                                    label: '没有',
                                    value: 0
                                }, {
                                    label: '曾经有',
                                    value: 1
                                }]
                            }, {
                                label: "曾经有注明",
                                prop: "serviceSituationRemarks",
                                bind: 'orderPersonalData.serviceSituationRemarks'
                            },
                            {
                                label: "现使用相关服务记录",
                                labelWidth: 170,
                                prop: "serviceSituationRecord",
                                bind: 'orderPersonalData.serviceSituationRecord',
                                type: "select",
                                dataType: "number",
                                dicData: [{
                                    label: '没有',
                                    value: 0
                                }, {
                                    label: '现没有',
                                    value: 1
                                }]
                            }, {
                                label: "现有注明",
                                prop: "serviceSituationNow",
                                bind: 'orderPersonalData.serviceSituationNow'
                            }
                        ]
                    }, {
                        label: '亲属关系',
                        arrow: false,
                        prop: 'qs',
                        labelWidth: 0,
                        column: [{
                            prop: 'qsgx',
                            span: 24,
                            row: true
                        }]
                    }, {
                        label: '初始计划单',
                        arrow: false,
                        prop: 'group5',
                        labelWidth: 0,
                        column: [{
                            prop: 'jhd',
                            span: 24,
                            row: true
                        }]
                    },
                    {
                        arrow: false,
                        prop: 'group6',
                        labelWidth: 0,
                        column: [{
                            prop: 'detailInit',
                            span: 24,
                            row: true
                        }]
                    }
                ]
            },
            planList: [],
            implementList: []

        }
    },
    mounted() {
        this.init()
        getDictionary({ code: "order_status" }).then(res => {
            const column = this.findObject(this.option.group, "starOrderStatusList");
            let list = res.data.data.filter(v => v.dictKey <= 100)
            column.dicData = list
        })

        let column2 = this.findObject(this.option.group, 'crimeType')
        getDictTree().then(res => {
            let list = res.data.data.filter(v => v.code == 'crime_types')[0].children
            column2.dicData = list
        })

    },
    methods: {
        init() {
            this.auditStatus = this.status
            this.obj = this.detail
            this.planList = []
            this.orderInitialPlanList = this.detail.orderInitialPlanList.filter(v => v.id == (this.$route.query.id || this.initOrderId))
			// console.log("获得:",this.detail.orderInitialPlanList);
            // this.orderInitialPlanList = this.detail.orderInitialPlanList
            this.orderKinshipList = this.detail.orderKinshipList
            this.starOrderJudicialList = this.detail.starOrderJudicialList
            this.showOpt = this.isOpt
            if ((this.isOpt || this.isShenHe || this.isSuccess) && this.initOrderId) {
                let column = this.option.group.find(v => v.prop == 'group6');
                column.display = this.showOpt || this.isShenHe || this.isSuccess
            }
        },
        getorderInitialPlanList(list) {
            this.planList = list
			this.detail.orderInitialPlanList[0].orderSpecificList = list
			// console.log("content",this.obj.orderInitialPlanList[0].orderSpecificList[1].content)
			for(let key in list){
				if(list[key].orderSpecificImageList.length == 0){
					this.specificImageBytext=true;
					break
				}
				for(let i in list[key].orderSpecificImageList){
					if(list[key].orderSpecificImageList[i].note!=""){
						this.specificImageBytext=false
				    }else{
						this.specificImageBytext=true;
						break
					}
				}
			}
			
        },
        printHandle() {
            this.$Print('#test');
        },
        closeVisible() {
            this.$emit("close")
        },
        submit(form) {
            if (this.isOpt) {
				if(this.specificImageBytext){
					this.$message.error("请提交具体计划实施图片及相关说明!")
					return;
				}
                let num = 0
                this.planList.map(v => {
                    if (v.orderSpecificImageList.length > 0 || v.pdfUrls.length > 0) {
                        num = num + 1
                    }
                })
                if (num == this.planList.length) {
                    submitAudit2Handle(this.initOrderId).then(res => {
                        this.$message.success("已提交审核")
                        this.examinelVisible = false
                        this.$emit("close")
                    })
                } else {
                    this.$message.error("请添加上传全部具体计划单实施执行的内容，每个具体计划单都必须上传图片或文件。")
                }

            } else if (this.isShenHe) {
                this.examinelVisible = true
            }
        },
        submitExaminel(form, done) {
            let json = {
                orderInitialPlanId: this.initOrderId,
                remark: form.remark
            }
            if (this.auditStatus == 2) {
                json.result = form.result * 1 == 1 ? 4 : 3
                auditTwoHandle(json).then(res => {
                    this.$message.success("已审核")
                    this.examinelVisible = false
                    this.$emit("close")
                    done()
                }).catch(() => {
                    done()
                })
            } else {
                json.result = form.result * 1 == 1 ? 7 : 6
                auditOneHandle(json).then(res => {
                    this.$message.success("已审核")
                    this.examinelVisible = false
                    this.$emit("close")
                    done()
                }).catch(() => {
                    done()
                })
            }

        },
    }
}

</script>
<style lang="scss">
// @import "@/styles/moudles/order.scss";
.order-detail-wrapper1 {
    .txt {
        font-size: 12px;
        color: #606266;
    }

    .el-form-item--small.el-form-item {
        margin-bottom: 0;
    }
}

</style>
